import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';




export const snapGoodsOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    // menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "抢购商品名称",
            prop: "name",
            search: true,
            type: "input"
        }, {
            label: '销售代理商',
            prop: 'agentId',
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
            formsolt: true,
        }, {
            label: '所属代理商',
            prop: 'company',
            hide: true,
            addVisdiplay: false,
            viewVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '商品品牌',
            prop: 'brandName',
            formsolt: true,
        },
        {
            label: '商品型号',
            prop: 'type',
            type: "input"
        },
        {
            label: '商品单位',
            prop: 'unit',
            type: "input"
        },
        {
            label: "",
            prop: "goodsPrices",
            span: 24,
            solt: true,
            hide: true,
            formsolt: true
        },
        {
            label: "描述图片",
            prop: "describeImgs",
            span: 24,
            hide: true,
            solt: true,
            formsolt: true
        }, {
            label: "轮播图片",
            prop: "wheelsImgs",
            span: 24,
            solt: true,
            hide: true,
            formsolt: true
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status1",
            type: "input",
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "拒绝理由",
            prop: "reason",
            type: "input",
            placeholder: " ",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: "状态",
            prop: "status",
            type: "radio",
            dicData: DIC.PRODUCT_STATUS,
            hide: true,
            addVisdiplay: false,
            search: true,
            editVisdiplay: false
        }

    ]
};